import { EUROPACE_INSURED_RISKS } from 'cpool-constants';
import type { SchemaResidualDebtInsurance } from 'cpool-schemas';
import { objectKeys } from 'cpool-schemas';

import { cn } from '~/utils/cnTailwind';

type Props = {
    applicant1ResidualDebtInsurance: SchemaResidualDebtInsurance | string[] | null;
    applicant2ResidualDebtInsurance: SchemaResidualDebtInsurance | string[] | null;
    /** Overrides the cell styling so the component fits tables with their own cell design. */
    className?: string;
};

export const RSV: React.FC<Props> = ({
    applicant1ResidualDebtInsurance,
    applicant2ResidualDebtInsurance,
    className,
}) => {
    return (
        <td className={cn('text-10 text-center text-grey whitespace-nowrap p-1', className)}>
            <div className="flex flex-col items-center justify-center gap-0.5">
                <div className="flex items-center justify-center gap-0.5">
                    {objectKeys(EUROPACE_INSURED_RISKS).map((risk) => {
                        return (
                            <span
                                data-testid={`applicant-traffic-light-${risk}`}
                                key={risk}
                                className={`w-2.5 h-2.5 rounded-full ${
                                    applicant1ResidualDebtInsurance?.includes(risk) ? 'bg-green' : 'bg-gray-400'
                                } inline-block`}
                            />
                        );
                    })}
                </div>
                {applicant2ResidualDebtInsurance && (
                    <div className="flex items-center justify-center gap-0.5">
                        {objectKeys(EUROPACE_INSURED_RISKS).map((risk) => {
                            return (
                                <span
                                    data-testid={`applicant-traffic-light-${risk}`}
                                    key={risk}
                                    className={`w-2.5 h-2.5 rounded-full ${
                                        applicant2ResidualDebtInsurance?.includes(risk) ? 'bg-green' : 'bg-gray-400'
                                    } inline-block`}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </td>
    );
};
